import api from "./api";

export const STORAGE_OPEN_PEDIDO = "econdo_open_pedido_id";

const qs = (p) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== "" && v !== undefined && v !== null)
);

const pedidosService = {
  meta: () => api("GET", "/pedidos/meta"),
  listar: (p = {}) => api("GET", `/pedidos?${qs(p)}`),
  buscarPorId: (id) => api("GET", `/pedidos/${id}`),
  criar: (data) => api("POST", "/pedidos", data),
  atualizar: (id, data) => api("PUT", `/pedidos/${id}`, data),
  alterarStatus: (id, status) => api("PATCH", `/pedidos/${id}/status`, { status }),
  gerarReposicao: (data) => api("POST", "/pedidos/gerar-reposicao", data),
  importarItens: (id, data) => api("POST", `/pedidos/${id}/importar-itens`, data),
};

export default pedidosService;
